import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { AjaxRequestPublisher } from 'src/commons/utils/metrics';
import { logger } from 'src/commons/utils/logger';
import cleanUrl from './clean-url';
import {
  NETWORK_ERROR_REGEX,
  REQUEST_ERROR_REGEX,
  REQUEST_TIMEOUT,
} from './constants';

export default async <T>(
  configOverrides: AxiosRequestConfig,
): Promise<AxiosResponse<T>> => {
  const startTime = performance.now();
  const config: AxiosRequestConfig = {
    method: 'GET',
    timeout: REQUEST_TIMEOUT,
    withCredentials: true,
    ...configOverrides,
  };
  const cleanedUrl = cleanUrl(configOverrides.url || '');
  const metricSlug = `${cleanedUrl}:${config.method}`;
  const successMetric = `${metricSlug}:success`;
  const networkFailureMetric = `${metricSlug}:networkFailure`;
  const requestAbortedMetric = `${metricSlug}:requestAborted`;
  const latencyMetric = `${metricSlug}:latency`;
  try {
    const response = await axios(config);
    AjaxRequestPublisher.publishCounterMonitor(successMetric, 1);
    return response;
  } catch (e: any) {
    logger.error(`Failed ${config.method} request to '${cleanedUrl}'`);
    AjaxRequestPublisher.publishCounterMonitor(successMetric, 0);
    if (NETWORK_ERROR_REGEX.test(e.message)) {
      AjaxRequestPublisher.publishCounterMonitor(networkFailureMetric, 1);
    } else if (REQUEST_ERROR_REGEX.test(e.message)) {
      AjaxRequestPublisher.publishCounterMonitor(requestAbortedMetric, 1);
    }
    throw e;
  } finally {
    const latency = performance.now() - startTime;
    AjaxRequestPublisher.publishTimer(latencyMetric, latency);
  }
};
